import { ColumnGroupTypes, ConstantColumns } from 'src/helpers/modular/detailedSummaryReport/interfaces';
export const userNameReportColumn = {
    name: ConstantColumns.UserName,
    key: 'userName',
    columnGroup: ColumnGroupTypes.UserData,
    valueExtractor: (reportRow) => reportRow.userData.userName,
    minWidth: 200,
    showTip: true
};
export const userCodeReportColumn = {
    name: ConstantColumns.UserCode,
    key: 'userCode',
    columnGroup: ColumnGroupTypes.UserData,
    valueExtractor: (reportRow) => reportRow.userData.userCode,
    minWidth: 100,
    showTip: true
};
export const departmentNameReportColumn = {
    name: ConstantColumns.DepartmentName,
    key: 'departmentName',
    columnGroup: ColumnGroupTypes.UserData,
    valueExtractor: (reportRow) => reportRow.userData.departmentName,
    minWidth: 250,
    showTip: true
};
export const departmentCodeReportColumn = {
    name: ConstantColumns.DepartmentCode,
    key: 'departmentCode',
    columnGroup: ColumnGroupTypes.UserData,
    valueExtractor: (reportRow) => reportRow.userData.departmentCode,
    minWidth: 130,
    showTip: true
};
export const professionNameReportColumn = {
    name: ConstantColumns.ProfessionName,
    key: 'professionName',
    columnGroup: ColumnGroupTypes.UserData,
    valueExtractor: (reportRow) => reportRow.userData.professionName,
    minWidth: 200,
    showTip: true
};
export const userDataColumnGroup = {
    name: ColumnGroupTypes.UserData,
    showName: true,
    key: ColumnGroupTypes.UserData,
    columns: [
        userNameReportColumn,
        userCodeReportColumn,
        departmentNameReportColumn,
        departmentCodeReportColumn,
        professionNameReportColumn
    ]
};
export const periodNormReportColumn = {
    name: ConstantColumns.PeriodNorm,
    key: 'periodNorm',
    columnGroup: ColumnGroupTypes.PeriodNormGroup,
    valueExtractor: (reportRow) => reportRow.periodNorm,
    cellClassNames: 'text-right',
    minWidth: 66
};
export const periodNormColumnGroup = {
    name: ColumnGroupTypes.PeriodNormGroup,
    showName: false,
    key: ColumnGroupTypes.PeriodNormGroup,
    columns: [periodNormReportColumn]
};
export const userActualColumn = {
    name: ConstantColumns.UserActual,
    shortName: 'UserActual-Short',
    key: 'userActual',
    columnGroup: ColumnGroupTypes.ActualGroup,
    valueExtractor: (reportRow) => reportRow.userActual,
    cellClassNames: 'text-right'
};
export const userActualColumnGroup = {
    name: ColumnGroupTypes.ActualGroup,
    showName: false,
    key: ColumnGroupTypes.ActualGroup,
    columns: [userActualColumn]
};
export const individualNormColumn = {
    name: ConstantColumns.IndividualNorm,
    shortName: 'IndividualNorm-Short',
    key: 'individualNorm',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.workHours.individualNorm,
    cellClassNames: 'text-right'
};
export const individualNormColumnGroup = {
    name: ColumnGroupTypes.IndividualNormGroup,
    showName: false,
    key: ColumnGroupTypes.IndividualNormGroup,
    columns: [individualNormColumn]
};
export const workTimeColumn = {
    name: ConstantColumns.WorkTime,
    shortName: 'WorkTime-Short',
    key: 'work',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.workHours.work,
    cellClassNames: 'text-right'
};
export const workTimeColumnGroup = {
    name: ColumnGroupTypes.WorkTimeGroup,
    showName: false,
    key: ColumnGroupTypes.WorkTimeGroup,
    columns: [workTimeColumn]
};
export const extraWorkColumn = {
    name: ConstantColumns.ExtraWork,
    shortName: 'ExtraWork-Short',
    key: 'extra',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.workHours.extra,
    cellClassNames: 'text-right'
};
export const trainingColumn = {
    name: ConstantColumns.Training,
    shortName: 'Training-Short',
    key: 'training',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.workHours.training,
    cellClassNames: 'text-right'
};
export const watchColumn = {
    name: ConstantColumns.Watch,
    shortName: 'Watch-Short',
    key: 'watch',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.workHours.watch,
    cellClassNames: 'text-right'
};
export const contractTransferedFreeTimeColumn = {
    name: ConstantColumns.ContractTransferedFreeTime,
    shortName: 'ContractTransferedFreeTime-Short',
    key: 'contractTransferedFreeTime',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.contractTransferedFreeTime,
    cellClassNames: 'text-right'
};
export const contractUsedFreeTimeColumn = {
    name: ConstantColumns.ContractUsedFreeTime,
    shortName: 'ContractUsedFreeTime-Short',
    key: 'contractUsedFreeTime',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.contractUsedFreeTime,
    cellClassNames: 'text-right'
};
export const contractUnusedFreeTimeColumn = {
    name: ConstantColumns.ContractUnusedFreeTime,
    shortName: 'ContractUnusedFreeTime-Short',
    key: 'contractUnusedFreeTime',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.contractUnusedFreeTime,
    cellClassNames: 'text-right'
};
export const freeTimeColumnGroup = {
    name: ColumnGroupTypes.FreeTimeTransfer,
    showName: true,
    key: ColumnGroupTypes.FreeTimeTransfer,
    columns: [contractTransferedFreeTimeColumn, contractUsedFreeTimeColumn, contractUnusedFreeTimeColumn]
};
export const freeDaysColumn = {
    name: ConstantColumns.FreeDays,
    shortName: 'FreeDays-Short',
    key: 'freeDays',
    columnGroup: ColumnGroupTypes.FreeDays,
    valueExtractor: (reportRow) => reportRow.freeDays,
    cellClassNames: 'text-right'
};
export const freeDaysColumnGroup = {
    name: ConstantColumns.FreeDays,
    showName: true,
    key: ColumnGroupTypes.FreeDays,
    columns: [freeDaysColumn]
};
export const overUnderColumn = {
    name: ConstantColumns.OverUnder,
    shortName: 'OverUnder-Short',
    key: 'overUnder',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.overUnder,
    cellClassNames: 'text-right'
};
export const contractOverUnderColumn = {
    name: ConstantColumns.ContractOverUnder,
    shortName: 'ContractOverUnder-Short',
    key: 'contractOverUnder',
    columnGroup: ColumnGroupTypes.CalculatedWorkHours,
    valueExtractor: (reportRow) => reportRow.contractOverUnder,
    cellClassNames: 'text-right'
};
